import { TenantStore } from './tenant.store';
import { QuoteStore } from './quote.store';
import { SignUpStore } from './sign-up.store';
import { makeAutoObservable } from 'mobx';
import { OnboardingInformationStore } from './onboarding-information.store';
import { DelegationInformationStore } from './delegation-information.store';
import { AddressStore } from './address.store';
import { BillingInformationStore } from './billing-information.store';
import { ContactsStore } from './contacts-store';
import { PaymentInformationStore } from './payment-information.store';
import { ShippingInformationStore } from './shipping-information';
import { ReviewStore } from './review.store';

export class RootStore {
  tenantStore: TenantStore;
  quoteStore: QuoteStore;
  signUpStore: SignUpStore;
  onboardingContactsStore: ContactsStore;
  onboardingInformationStore: OnboardingInformationStore;
  delegationInformationStore: DelegationInformationStore;
  serviceAddressStore: AddressStore;
  shippingAddressStore: AddressStore;
  shippingContactStore: ContactsStore;
  shippingInformationStore: ShippingInformationStore;
  billingAddressStore: AddressStore;
  billingContactsStore: ContactsStore;
  paymentInformationStore: PaymentInformationStore;
  billingInformationStore: BillingInformationStore;
  reviewStore: ReviewStore;
  adminContactStore: ContactsStore;

  constructor() {
    makeAutoObservable(this);
    this.tenantStore = new TenantStore(this);
    this.quoteStore = new QuoteStore(this);
    this.signUpStore = new SignUpStore(this);
    this.onboardingInformationStore = new OnboardingInformationStore(this);
    this.delegationInformationStore = new DelegationInformationStore(this);
    this.serviceAddressStore = new AddressStore(this);
    this.shippingAddressStore = new AddressStore(this);
    this.billingAddressStore = new AddressStore(this);
    this.shippingInformationStore = new ShippingInformationStore(this);
    this.billingInformationStore = new BillingInformationStore(this);
    this.onboardingContactsStore = new ContactsStore(this);
    this.shippingContactStore = new ContactsStore(this);
    this.billingContactsStore = new ContactsStore(this);
    this.paymentInformationStore = new PaymentInformationStore(this);
    this.reviewStore = new ReviewStore(this);
    this.adminContactStore = new ContactsStore(this);
  }

  public async init(): Promise<void> {
    await Promise.all([this.tenantStore.init().then(() => this.quoteStore.init())]).then(() => {
      this.onboardingInformationStore.init();
      this.delegationInformationStore.init();
      this.serviceAddressStore.init('service');
      this.shippingInformationStore.init();
      this.billingInformationStore.init();
      this.reviewStore.init();
    });
  }
}
